<template>
  <div class="content">
    <card title="水位库容">
      <div class="card_content">
        <div class="item_list fb">
          <div class="item box_style fs" v-for="(item, index) in waterData" :key="index">
            <div class="icon">
              <img :src="`${require(`@/assets/hs/icon_4_${index + 1}.png`)}`" alt="" class="Img" />
            </div>
            <div class="info">
              <p class="value light" v-if="item.signage == 'wptn'">{{ shuishiMap[item.value] }}</p>
              <p class="value light" v-else>{{ item.value | FormatNumber }}</p>
              <!-- <p class="value light">{{ item.value | FormatNumber }}</p> -->
              <p class="name">{{ item.fieldName }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="chart_box box_style">
        <div id="waterChart" ref="waterChart" class="water_echart"></div>
      </div>
    </card>

    <card title="大坝位移" styles="margin-top:24px">
      <div class="qa_list_name_box fb">
        <div class="list_item box_style">
          <p class="name">1212</p>
        </div>
        <div class="list_item box_style">
          <p class="name">1213</p>
        </div>
      </div>

      <div class="qa_list_box fb">
        <div class="list_item box_style" v-for="(item, index) in weiyiData1" :key="index">
          <p class="name">{{ item.fieldName }}</p>
          <p class="value light">{{ item.value }}</p>
        </div>
        <div class="list_item box_style" v-for="(item, index) in weiyiData2" :key="index">
          <p class="name">{{ item.fieldName }}</p>
          <p class="value light">{{ item.value }}</p>
        </div>
      </div>
    </card>

    <card title="大坝渗压" styles="margin-top:24px">
      <div class="safe_list_box box_style fr">
        <div class="list_item fc" v-for="(item, index) in shenyaData" :key="index">
          <!-- <div class="icon">
            <img :src="`${require(`@/assets/hs/icon_5_1.png`)}`" alt="" class="Img" />
          </div> -->
          <div class="info">
            <p class="value light">{{ item.value }}</p>
            <p class="name">{{ item.fieldName }}</p>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import Card from '@/components/Card.vue';
import * as Api from '@/api';
export default {
  name: 'ShuiGongJianZhu',
  components: {
    Card,
  },
  data() {
    return {
      waterlistData: [
        { code: 'frontWaterLevel', name: '前池水位(m)', icon: 'icon_4_1', value: 0 },
        { code: 'limitWaterLevel', name: '限制水位(m)', icon: 'icon_4_2', value: 0 },
        { code: 'runDay', name: '安全运行', icon: 'icon_4_3', value: 0 },
      ],
      waterChartOpt: {
        grid: {
          top: '20%',
          left: '3%',
          right: '5%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [1, 2, 3, 4, 5, 6, 7, '万m³'],
          //x 轴线的颜色以及宽度
          show: true,
          axisTick: {
            show: false,
          },
          axisLabel: {
            //x 轴文字的配置
            show: true,
            textStyle: {
              color: '#86AAC4',
            },
          },
        },
        yAxis: {
          name: '水位/m',
          nameTextStyle: { color: '#86AAC4' },
          type: 'value',
          axisLine: {
            //y 轴线的颜色以及宽度
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            //y 轴文字的配置
            show: true,
            textStyle: {
              color: '#86AAC4',
            },
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            data: [0.6, 0.9, 1.2, 1.1, 1.5, 0.5, 0.8],
            type: 'line',
            lineStyle: {
              color: '#2FA3BE',
              width: 1,
            },
            symbol: 'none', //不显示点
            areaStyle: {
              color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(57,192,210,0.23)',
                },
                {
                  offset: 1,
                  color: 'rgba(60,231,255,0)',
                },
              ]),
            },
            smooth: true,
          },
        ],
      },
      qaListData: [
        { name: '溶解氧(mg/L)', value: '18' },
        { name: 'pH值(-)', value: '13' },
        { name: '电导率(uS/cm)', value: '20000' },
        { name: '浊度(NTU)', value: '4000' },
        { name: '温度(°C)', value: '55' },
      ],
      waterData: [],
      shuishiMap: {
        4: '落',
        5: '涨',
        6: '平',
      },
      weiyiData1: [],
      weiyiData2: [],
      shenyaData: [],
      stationInfo: {},
    };
  },
  mounted() {
    this.stationInfo = this.$Storage.get('stationInfo');
    const { frontCurveMap } = this.stationInfo;
    this.$nextTick(() => {
      this.renderCharts(frontCurveMap);
    });
    this.renderData();
  },
  methods: {
    renderData() {
      // 库雨量 水势
      Api.getRealData({ deviceCode: 'RR50705074' }).then((res) => {
        this.waterData = res.data;
        // 库水位RR50705074_ZC
        this.waterData[0].value = this.$Storage.get('curWaterPosition') || 0;
        // this.waterlistData.forEach((item, index) => {
        //   this.$set(this.waterlistData[index], 'value', this.stationInfo[item.code]);
        //   this.$forceUpdate();
        // });
      });
      // 大坝渗压
      Api.getRealData({ deviceCode: 'DAM50705074_FF' }).then((res) => {
        this.shenyaData = res.data;
      });
      // 大坝位移1
      Api.getRealData({ deviceCode: 'DAM50705074_1212' }).then((res) => {
        this.weiyiData1 = res.data;
      });
      // 大坝位移2
      Api.getRealData({ deviceCode: 'DAM50705074_1213' }).then((res) => {
        this.weiyiData2 = res.data;
      });
    },
    renderCharts(frontCurveMap) {
      const waterChartDataValue = [];
      const waterChartDataKey = [];
      Object.keys(frontCurveMap).forEach((item) => {
        waterChartDataValue.push(frontCurveMap[item]);
        waterChartDataKey.push(item);
      });
      this.waterChartOpt.xAxis.data = waterChartDataKey;
      this.waterChartOpt.series[0].data = waterChartDataValue;
      let waterChart = this.$echarts.init(document.getElementById('waterChart'));
      waterChart.setOption(this.waterChartOpt);
    },
  },
};
</script>

<style lang="scss" scoped>
.card_content {
  .item_list {
    flex-wrap: wrap;
    .item {
      width: 152px;
      height: 80px;
      margin-bottom: 12px;
      cursor: pointer;
      .icon {
        margin-left: 14px;
      }
      .info {
        margin-left: 10px;
        .value {
          font-size: 20px;
        }
      }
    }
  }
}
.chart_box {
  width: 480px;
  height: 268px;
  .water_echart {
    width: 100%;
    height: 100%;
  }
}
.qa_list_name_box {
  width: 100%;
  .list_item {
    height: 40px;
    width: 50%;
    text-align: center;
    .name {
      font-size: 18px;
      font-weight: bold;
    }
  }
}
.qa_list_box {
  width: 100%;
  .list_item {
    flex: 0 0 auto;
    height: 60px;
    padding: 0 9px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    .name {
      margin-bottom: 3px;
    }
    .value {
      font-size: 20px;
      font-weight: 500;
      margin-bottom: 5px;
    }
  }
}
.safe_list_box {
  width: 480px;
  height: 122px;
  .list_item {
    width: 234px;
    height: 96px;
    .icon {
      width: 80px;
      height: 80px;
    }
    .info {
      margin-left: 20px;
      .value {
        font-size: 20px;
      }
    }
  }
}
</style>
